import script from "./CrowdfundingLiveOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingLiveOrganism.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingLiveOrganism.vue?vue&type=style&index=0&id=96a996d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96a996d2"]])

export default __exports__